(function () {
  var section = document.querySelector('.coverax-faq-page');
  if (!section) return;

  var searchInput = section.querySelector('[data-faq-search]');
  var items = section.querySelectorAll('[data-faq-item]');
  var groups = section.querySelectorAll('[data-faq-group]');
  var emptyState = section.querySelector('[data-faq-empty]');

  if (!searchInput) return;

  function normalize(text) {
    return (text || '').toLowerCase();
  }

  function applyFilters() {
    var query = normalize(searchInput.value);
    var visibleCount = 0;

    items.forEach(function (item) {
      var haystack = normalize(item.getAttribute('data-faq-question')) + ' ' + normalize(item.getAttribute('data-faq-answer'));
      var visible = query === '' || haystack.indexOf(query) !== -1;

      item.hidden = !visible;
      if (visible) visibleCount += 1;
    });

    groups.forEach(function (group) {
      var hasVisibleItem = group.querySelector('[data-faq-item]:not([hidden])');
      group.hidden = !hasVisibleItem;
    });

    if (emptyState) {
      emptyState.hidden = visibleCount !== 0;
    }
  }

  searchInput.addEventListener('input', applyFilters);
})();
